module.exports = "https://cdn2-fs.clearscore.com/flux/images/3f31ef45ea2e06e7f6153e66c9d927ef.jpg";